<template>
  <div id="app">
    
    <header>

      <app-header></app-header>

    </header>

    <section>

      <app-main></app-main>

    </section>

    <footer>

      <app-footer></app-footer>

    </footer>

  </div>

</template>

<script>
import Header from './components/header/Header.vue'
import Main from './components/main/Main.vue'
import Footer from './components/footer/Footer.vue'

export default {
  name: 'App',
  components: {
    appHeader: Header,
    appMain: Main,
    appFooter: Footer
  }
}
</script>

<style scoped lang="scss">

#app {
  margin-left: 3vw;
  margin-right: 3vw;

  height: 100%;

  *:not(:last-child) {
    margin-bottom: 2rem;
  }
} 

</style>
